import { useDisclosure } from "@chakra-ui/hooks";
import React from "react";
import { useGetOrganisation } from "@tether-web-portal/api/organisations/hooks";
import { AuthUser } from "../../lib/auth/AuthProvider";
import SwitchOrganisationModal from "../switch-organisation/SwitchOrganisationModal";
import { AccountSwitcher } from "./AccountSwitcher";

interface AccountSwitcherContainerProps {
  user: AuthUser;
  onLogout: () => void;
  isCovidCareHeader?: boolean;
  isCollapsed?: boolean;
}

export const AccountSwitcherContainer = ({
  onLogout,
  user,
  isCovidCareHeader,
  isCollapsed,
}: AccountSwitcherContainerProps) => {
  // The current organisation by id: it need not be on any page of the switcher's list.
  const { organisation } = useGetOrganisation(user.currentOrganisationId);
  const organisationName = organisation?.name;

  const {
    isOpen: isOrganisationSwitcherOpen,
    onOpen: onOpenOrganisationSwitcher,
    onClose: onCloseOrganisationSwitcher,
  } = useDisclosure();
  return (
    <>
      <SwitchOrganisationModal
        currentOrganisationId={user.currentOrganisationId}
        onClose={onCloseOrganisationSwitcher}
        isOpen={isOrganisationSwitcherOpen}
        currentOrganisationName={organisationName}
        isCovidCareHeader={isCovidCareHeader}
      />
      <AccountSwitcher
        onClickChangeOrganisation={onOpenOrganisationSwitcher}
        organisationName={organisationName}
        user={user}
        onLogout={onLogout}
        isCovidCareHeader={isCovidCareHeader}
        isCollapsed={isCollapsed}
      />
    </>
  );
};
